import getSurfaceStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Changes activeSurface in surface store
 * @param newSurface, the new surface to be chosen
 */
const updateActiveSurface = mutatorAction('updateActiveSurface', ({ newSurface }) => {
    getSurfaceStore().activeSurfaceView = newSurface;
});

export default updateActiveSurface;
